import { get } from '@shared/adapters/lodash'
import {
  CRYPTO_WALLET_STATUS,
  TRUSTLINE_STATUS,
  type CryptoWalletStatus,
  type TrustlineStatus,
} from '../constants/walletStatus'
import type { WalletStatus } from '../types/walletTypes'

const WALLET_STATUS_VALUES: readonly string[] = Object.values(CRYPTO_WALLET_STATUS)
const TRUSTLINE_STATUS_VALUES: readonly string[] = Object.values(TRUSTLINE_STATUS)

const isWalletStatus = (value: unknown): value is CryptoWalletStatus =>
  typeof value === 'string' && WALLET_STATUS_VALUES.includes(value)

const isTrustlineStatus = (value: unknown): value is TrustlineStatus =>
  typeof value === 'string' && TRUSTLINE_STATUS_VALUES.includes(value)

export const parseWalletStatus = (resp: unknown): WalletStatus => {
  const walletStatus: unknown = get(resp, 'data.walletStatus')
  const trustlineStatus: unknown = get(resp, 'data.trustlineStatus')
  return {
    walletId: get(resp, 'data.walletId') ?? null,
    trustlineStatus: isTrustlineStatus(trustlineStatus) ? trustlineStatus : null,
    walletStatus: isWalletStatus(walletStatus) ? walletStatus : null,
    isReady: Boolean(get(resp, 'data.isReady')),
  }
}
